import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHome, FaSearch, FaExclamationTriangle } from 'react-icons/fa';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <>
      <SEO 
        title="Page Not Found - 404"
        description="The page you're looking for doesn't exist."
      />
      <Container className="py-5 text-center" style={{ minHeight: '60vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div className="mb-4">
          <FaExclamationTriangle size={80} className="text-warning" />
        </div>
        <h1 className="display-1 fw-bold text-primary">404</h1>
        <h2 className="mb-3">Page Not Found</h2>
        <p className="text-muted mb-4" style={{ maxWidth: '500px', margin: '0 auto' }}>
          Oops! The page you're looking for doesn't exist or has been moved. 
          Don't worry, you can find your way back.
        </p>
        <div className="d-flex justify-content-center gap-3 flex-wrap">
          <Button as={Link} to="/" variant="primary" size="lg">
            <FaHome className="me-2" /> Go Home
          </Button>
          <Button as={Link} to="/products" variant="outline-primary" size="lg">
            <FaSearch className="me-2" /> Browse Products
          </Button>
        </div>
      </Container>
    </>
  );
};

export default NotFound;
